<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${salesOrder.seq_number}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="salesOrder" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "sales-order-view-logs",

  components: { LogListTable },

  props: ["salesOrder"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
